import Tag from "./Tag";
import TagCollection from "./TagCollection";

export default class TagContainer
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-day-search-edibles-showcase-tags`;

	getTagCollection()
	{
		return new TagCollection(Array.from(this.el.querySelectorAll(Tag.selector())).map(el => {
			return new Tag(el);
		}));
	}

	hide()
	{
		this.el.hidden = true;

		return this;
	}

	show()
	{
		this.el.hidden = false;

		return this;
	}

	reset()
	{
		this.getTagCollection().reset();

		return this;
	}
}
